// src/styles/base/panels.ts
/**
 * The two panel treatments, shared so a tile or a header cannot drift from its siblings.
 * Colours come from the panel roles in tokens.ts.
 */
import { colors } from './tokens';

/** Chart card headers and table header cells: pale fill, Blue rule beneath */
export const panelHeaderSx = {
    backgroundColor: colors.panelFill,
    color: colors.panelText,
    borderBottom: `2px solid ${colors.panelRule}`,
} as const;

/** KPI tiles: pale fill, Blue rule above */
export const panelTileSx = {
    backgroundColor: colors.panelFill,
    color: colors.panelText,
    borderTop: `3px solid ${colors.panelRule}`,
} as const;
